module.exports = __webpack_public_path__ + "img/mon_24.fa5366df.png";